import { fetchAppointments } from "../../redux/slices/appointmentsSlice";
import { fetchClients } from '../../redux/slices/clientsSlice';
import { fetchMasterSession } from "../../redux/slices/masterSessionSlice";
import { fetchUserSession } from "../../redux/slices/userSessionSlice";

export const loadMasterAppointmentsData = async (masterId, dispatch) => {
    const promises = [
        // dispatch(fetchAllAppointments()),
        // dispatch(fetchAppointments(masterId)),
        dispatch(fetchClients(masterId)),
        dispatch(fetchMasterSession()),
        dispatch(fetchUserSession())
            .unwrap()
            .then((data) => {
                
            })
            .catch((err) => {
                
            })];

    await Promise.all(promises);
};
